import React, { useCallback } from 'react';

import ComponentPropTypes from './ComponentPropTypes';
import _ from 'lodash';
import { createPathUrl } from '../../NodePage/location';
import TreeSelection from '../../TreeSelection/TreeSelection';

export const TreeSelectionComponent = ({ model, value, onChange }) => {
  const onTreeRootChange = useCallback((root) => {
    onChange(model, { ...value, root });
  }, [onChange, model, value]);

  const onSelectionsChanged = useCallback((val) => {
    onChange(model, { ...value, selections: _.map(val, v => createPathUrl(v, 'view')) });
  }, [onChange, model, value]);

  const onAllowedSelectionChange = useCallback((val) => {
    onChange(model, { ...value, allowedSelection: val });
  }, [onChange, model, value]);

  return (<TreeSelection
    initialRoot={value?.root}
    selections={value.selections}
    onTreeRootChange={onTreeRootChange}
    onSelectionsChanged={onSelectionsChanged}
    onAllowedSelectionChange={onAllowedSelectionChange} />);
};


TreeSelectionComponent.propTypes = ComponentPropTypes;

export default React.memo(TreeSelectionComponent);
